// project import
import { useMemo } from 'react';
import { NavItemType } from 'types/menu';
import useDashboardItems from './dashboard-items';

// ==============================|| MENU ITEMS ||============================== //

const useMenuItems = () => {
  const dashboardItems = useDashboardItems();

  const menuItems: { items: NavItemType[] } = useMemo(
    () => ({
      items: [dashboardItems]
    }),
    [dashboardItems]
  );

  return menuItems;
};

export default useMenuItems;
